import type { Observation, RunRecord, RunRequest } from '@geoprice/shared';

export interface RunSummary { total: number; completed: number; queued: number; comparable: number; unavailable: number; blocked: number; failed: number }
export type RunView = RunRecord & { summary: RunSummary };
export interface AppConfig {
  proxyConfigured: boolean; liveRetailerConfigured: boolean; publicDemoMode: boolean;
  testProductUrl: string; maxLocations: number; defaultConcurrency: number; maxConcurrency: number;
}
export interface NearbyLocationsResult {
  center: { zip: string; city: string; state: string; latitude?: number; longitude?: number };
  radiusMiles: number;
  locations: RunRequest['locations'];
}

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, { ...init, headers: { 'content-type': 'application/json', ...init?.headers } });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error ?? `Request failed (${response.status})`);
  return payload as T;
}

export const api = {
  config: () => request<AppConfig>('/api/config'),
  nearbyLocations: (body: { zip?: string; latitude?: number; longitude?: number; limit?: number; radiusMiles?: number }) => request<NearbyLocationsResult>('/api/locations/nearby', { method: 'POST', body: JSON.stringify(body) }),
  runs: () => request<RunView[]>('/api/runs'),
  run: (id: string) => request<RunView>(`/api/runs/${id}`),
  observation: (id: string) => request<Observation>(`/api/observations/${id}`),
  createRun: (body: RunRequest) => request<RunView>('/api/runs', { method: 'POST', body: JSON.stringify(body) }),
  action: (id: string, action: 'pause' | 'resume' | 'stop') => request<{ ok: boolean }>(`/api/runs/${id}/${action}`, { method: 'POST' })
};

export function evidenceUrl(path?: string) {
  if (!path) return undefined;
  const normalized = path.replaceAll('\\', '/');
  const match = normalized.match(/evidence\/([^/]+)\/([^/]+)$/);
  return match ? `/api/evidence/${match[1]}/${match[2]}` : undefined;
}
